import React from 'react'
import { connect } from 'react-redux'
import { Container } from 'react-bootstrap'

import "./styles/manage-styles.scss"
import ManageIntegrationTopBar from './pages/GoogleAnalyticsTable/Includes/ManageIntegrationTopBar'
import ManageIntegrationTable from './pages/GoogleAnalyticsTable/ManageIntegrationTable'
function Manage(props) {

    return (
        <section id="app-manage-integration" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-multipliers">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Manage Integrations</p>
                        <p className="app-desc">Manage Integration for API</p>
                    </div>

                    <div className="app-content-container">
                        <div className="app-card ">
                            <div className="app-card-content border st-default-rounded-block mb-3">
                                <ManageIntegrationTopBar />
                                <ManageIntegrationTable />
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section >
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     }
// }

export default connect(getDataFromStore, null)(Manage)